import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { blogPosts } from '../../data/mock';

const BlogSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="container-main">
        <h2 className="text-3xl md:text-4xl font-bold text-navy font-display text-center mb-10">Blogs</h2>

        <div className="grid md:grid-cols-2 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blogs/${post.id}`}
              className="group"
            >
              <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-100">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="text-xl font-semibold text-navy group-hover:text-lime transition-colors mb-2">
                {post.title}
              </h3>
              <p className="text-gray-500 text-sm">{post.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
